// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"583e212a","443":"48b959c8","496":"e9a43956","528":"b1693a66","665":"0bdfc68c","787":"34ea7fff"}[chunkId] + ".chunk.js";
};